import General from './modules/general';
import Menu from './modules/menu';
import Styles from './modules/styles';

document.addEventListener('DOMContentLoaded', () => {
    window.Menu = new Menu();
    window.Styles = new Styles();
    window.General = new General();
}, false);

